@if (selectedConversation) {
  <p-card
    class="chat-panel-card axede-card-variant-contrast"
    [style]="{ height: '100%' }"
  >
    <!-- Removed pTemplate="title" -->
    <!-- Use the new ChatTitleBarComponent -->
    <app-chat-title-bar
      [campaign]="campaign"
      [workspaceId]="workspaceId"
      [platformId]="platformId"
      [selectedConversation]="selectedConversation"
      [isTranslationEnabled]="isTranslationEnabled"
      [isInfoPanelVisible]="isInfoPanelVisible"
      [closeReasons]="closeReasons"
      [chatMessages]="chatMessages"
      [customVars]="customVariablesArray"
      (transferAgentRequested)="openCampaignDialog()"
      (translationToggled)="toggleTranslation()"
      (infoPanelToggled)="toggleInfoPanel()"
      (conversationCloseRequested)="closeConversation($event)"
    >
    </app-chat-title-bar>

    <ng-template pTemplate="content">
      <!-- Chat Panel View -->
      @if (!isInfoPanelVisible) {
        <div
          class="chat-panel-container"
          [ngClass]="panelTransitionClass"
          role="log"
          aria-live="polite"
        >
          <div
            class="chat-list-container"
            #chatListContainer
            [attr.aria-label]="'agent.chat.aria.chatMessages' | translate"
          >
            @if (chatMessages.length === 0) {
              <div class="empty-chat-message">
                <p>{{ 'agent.chat.noMessages' | translate }}</p>
              </div>
            }
            @for (item of chatMessages; track trackByMessageId($index, item)) {
              <div
                class="chat-item"
                [ngClass]="{
                  right: item?.type === AGENT_ROLE,
                  left: item?.type !== AGENT_ROLE,
                }"
                [attr.aria-label]="
                  (item?.type === AGENT_ROLE
                    ? 'agent.chat.aria.messageFromAgent'
                    : 'agent.chat.aria.messageFromClient'
                  ) | translate
                "
              >
                @if (isContextMessage(item)) {
                  <p-card
                    class="context-card axede-card-variant-contrast"
                    [header]="'agent.chat.context' | translate"
                  >
                    @for (
                      field of parseContextContent(item);
                      track field.label
                    ) {
                      <div class="context-field">
                        <div class="context-label">{{ field.label }}:</div>
                        <div class="context-value">{{ field.value }}</div>
                        <button
                          type="button"
                          pButton
                          class="p-button-text p-button-sm copy-btn"
                          icon="pi pi-copy"
                          [pTooltip]="'agent.chat.copy' | translate"
                          tooltipPosition="top"
                          (click)="copyToClipboard(field.value)"
                        ></button>
                      </div>
                    }
                  </p-card>
                } @else {
                  <p-avatar
                    [image]="
                      item?.type === AGENT_ROLE
                        ? '/assets/avatar_agent.png'
                        : '/assets/avatar_client.png'
                    "
                    icon="pi pi-user"
                    class="avatar axede-avatar"
                    size="normal"
                    shape="circle"
                    [attr.aria-hidden]="true"
                    [style]="{
                      'background-color':
                        item?.type === AGENT_ROLE
                          ? 'var(--axede-primary)'
                          : 'var(--axede-secondary)',
                      color: 'white',
                      border: '2px solid white',
                    }"
                  ></p-avatar>
                  <div class="message-content">
                    <div
                      class="message-body"
                      [ngClass]="{
                        sent: item?.type === AGENT_ROLE,
                        received: item?.type !== AGENT_ROLE,
                        'translation-active':
                          isTranslationEnabled &&
                          hasTranslation(item) &&
                          isTextMessage(item),
                      }"
                    >
                      @if (isTextMessage(item)) {
                        <!-- Pass original content to url, translation state and content separately "item.content"-->
                        <app-document-message
                          [url]="messageContentRender(item)"
                          [mediaType]="item.messageType"
                          [isTranslationEnabled]="isTranslationEnabled"
                          [contentTranslated]="
                            item.type === USER_ROLE &&
                            selectedConversation.metadata?.translationConfig
                              ?.enable
                              ? item.contentTranslated
                              : item.content
                          "
                        >
                        </app-document-message>
                      } @else {
                        <!-- For non-text, pass only url and mediaType -->
                        <app-document-message
                          [url]="item.content"
                          [mediaType]="item.messageType"
                        >
                        </app-document-message>
                      }
                      @if (
                        hasTranslation(item) &&
                        isTextMessage(item) &&
                        isTranslationEnabled
                      ) {
                        <div class="translation-indicator">
                          <i
                            class="pi pi-globe"
                            [pTooltip]="
                              (isTranslationEnabled
                                ? 'agent.chat.translation.showing'
                                : 'agent.chat.translation.available'
                              ) | translate
                            "
                            tooltipPosition="top"
                          >
                          </i>
                          @if (isTranslationEnabled) {
                            <span class="translation-text">
                              {{ 'agent.chat.translation.label' | translate }}
                            </span>
                          }
                        </div>
                      }
                    </div>
                    <div
                      class="time-details"
                      style="color: white !important; font-size: 12px"
                    >
                      {{ getMessageDate(item) | date: "hh:mm:ss a" : "UTC" }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <div
            class="chat-footer"
            role="form"
            [attr.aria-label]="'agent.chat.aria.messageForm' | translate"
          >
            <textarea
              pInputTextarea
              [(ngModel)]="chatInputMessage"
              autoResize="true"
              [placeholder]="'agent.chat.messagePlaceholder' | translate"
              class="chat-input"
              (keydown)="onKeyDown($event)"
              rows="1"
              [attr.aria-label]="'agent.chat.aria.messageToSend' | translate"
              [disabled]="!selectedConversation || agent?.role !== 'agent'"
            ></textarea>

            <!-- Control buttons container -->
            <div
              class="footer-controls"
              [hidden]="!selectedConversation || agent?.role !== 'agent'"
            >
              @if (
                selectedConversation.metadata?.translationConfig
                  ?.improveRedaction
              ) {
                <p-button
                  icon="pi pi-shield"
                  styleClass="p-button-rounded p-button-text footer-action-btn"
                  [pTooltip]="'agent.chat.improveRedaction.tooltip' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'agent.chat.improveRedaction.aria' | translate"
                  (click)="improveRedaction()"
                  [disabled]="!selectedConversation || agent?.role !== 'agent'"
                >
                </p-button>
              }

              <!-- File Upload Button -->
              <p-fileUpload
                #fileUploader
                mode="basic"
                name="chatFiles[]"
                [chooseLabel]="'agent.chat.attach' | translate"
                chooseIcon="pi pi-paperclip"
                [auto]="true"
                [customUpload]="true"
                (uploadHandler)="onFileUpload($event)"
                styleClass="axede-upload-button"
                [disabled]="!selectedConversation || agent?.role !== 'agent'"
                [pTooltip]="'agent.chat.attachFile.tooltip' | translate"
                tooltipPosition="top"
                [attr.aria-label]="'agent.chat.attachFile.aria' | translate"
              >
              </p-fileUpload>

              <!-- Default Messages Button -->
              @if (isDefaultMessagesEnabled) {
                <p-button
                  #defaultMessagesBtn
                  icon="pi pi-comment"
                  styleClass="p-button-rounded p-button-text footer-action-btn"
                  [pTooltip]="'agent.chat.defaultMessages.tooltip' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'agent.chat.defaultMessages.aria' | translate"
                  [disabled]="!selectedConversation || agent?.role !== 'agent'"
                  (click)="messagesPanel.toggle($event)"
                >
                </p-button>

                <p-overlayPanel
                  #messagesPanel
                  [showCloseIcon]="true"
                  [dismissible]="true"
                  styleClass="custom-overlay-panel"
                >
                  <div class="default-messages-panel">
                    <h4>{{ 'agent.chat.defaultMessages.title' | translate }}</h4>
                    <div class="messages-list">
                      @for (message of defaultMessages; track $index) {
                        <div
                          class="message-item"
                          (click)="selectDefaultMessage(message)"
                          [title]="message"
                        >
                          <i class="pi pi-comment"></i>
                          <span>{{ message }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </p-overlayPanel>
              }

              <!-- Default Questions Button -->
              @if (isDefaultQuestionsEnabled) {
                <p-button
                  #defaultQuestionsBtn
                  icon="pi pi-question-circle"
                  styleClass="p-button-rounded p-button-text footer-action-btn"
                  [pTooltip]="'agent.chat.defaultQuestions.tooltip' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'agent.chat.defaultQuestions.aria' | translate"
                  [disabled]="!selectedConversation || agent?.role !== 'agent'"
                  (click)="questionsPanel.toggle($event)"
                >
                </p-button>

                <p-overlayPanel
                  #questionsPanel
                  [showCloseIcon]="true"
                  [dismissible]="true"
                  styleClass="custom-overlay-panel"
                >
                  <div class="default-questions-panel">
                    <h4>{{ 'agent.chat.defaultQuestions.title' | translate }}</h4>
                    <div class="questions-list">
                      @for (qa of defaultQuestions; track $index) {
                        <div
                          class="question-item"
                          (click)="selectDefaultQuestion(qa)"
                        >
                          <div class="question">
                            <i class="pi pi-question-circle"></i>
                            <strong>{{ qa.question }}</strong>
                          </div>
                          <div class="answer" [title]="qa.answer">
                            {{ qa.answer }}
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </p-overlayPanel>
              }

              <!-- Emoji Panel -->
              <app-panel-emojies
                [maxEmojiPickerHeight]="maxEmojiPickerHeight"
                [isDarkMode]="isDarkMode"
                [emojiPickerTitle]="emojiPickerTitle"
                [disabled]="!selectedConversation || agent?.role !== 'agent'"
                (emojiSelected)="addEmoji($event)"
              >
              </app-panel-emojies>
            </div>
            <!-- Send Button -->
            <p-button
              icon="pi pi-send"
              styleClass="p-button-rounded axede-send-button"
              [disabled]="
                !chatInputMessage.trim() ||
                !selectedConversation ||
                agent?.role !== 'agent'
              "
              (click)="send()"
              [pTooltip]="'agent.chat.send.tooltip' | translate"
              tooltipPosition="top"
              [attr.aria-label]="'agent.chat.send.aria' | translate"
            ></p-button>
          </div>
        </div>
      }
      <!-- Information Panel View -->
      @else {
        <div
          class="info-panel-container"
          [ngClass]="panelTransitionClass"
          role="region"
          [attr.aria-label]="'agent.chat.aria.conversationInfo' | translate"
        >
          <div class="info-panel-content">
            <!-- Custom Variables Section (moved below the three-column config) -->
            @if (hasCustomVariables) {
              <div class="info-section custom-variables-section">
                <h3 class="info-section-title">
                  <i class="pi pi-list"></i>
                  {{ 'agent.chat.section.userData' | translate }}
                </h3>
                <div class="variables-display">
                  @for (variable of customVariablesArray; track variable.name) {
                    <div class="variable-item">
                      <div class="variable-label">{{ variable.name }}</div>
                      <div class="variable-value">
                        {{ variable.value || ('agent.chat.noValue' | translate) }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            }

            <div class="info-section">
              <h3 class="info-section-title">
                <i class="pi pi-megaphone"></i>
                {{ 'agent.chat.section.campaignInfo' | translate }}
              </h3>
              <div class="info-section-grid">
                @for (item of campaignMetadata; track $index) {
                  <div class="info-item">
                    <div class="info-label">{{ item.label }}</div>
                    <div class="info-value">{{ item.value }}</div>
                  </div>
                }
              </div>
            </div>

            <div class="info-section">
              <h3 class="info-section-title">
                <i class="pi pi-comments"></i>
                {{ 'agent.chat.section.conversationInfo' | translate }}
              </h3>
              <div class="info-section-grid">
                @for (item of conversationMetadata; track $index) {
                  <div class="info-item">
                    <div class="info-label">{{ item.label }}</div>
                    <div class="info-value">{{ item.value }}</div>
                  </div>
                }
              </div>
            </div>

            @if (campaign?.general_config) {
              <div class="info-section">
                <h3 class="info-section-title">
                  <i class="pi pi-cog"></i>
                  {{ 'agent.chat.section.generalConfig' | translate }}
                </h3>
                <div class="info-section-grid">
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.acceptConversation' | translate }}</div>
                    <div class="info-value">
                      {{
                        (campaign?.general_config?.accept_conversation
                          ? 'agent.chat.yes'
                          : 'agent.chat.no'
                        ) | translate
                      }}
                    </div>
                  </div>
                  <!-- Ticket input (if enabled in campaign) -->
                  @if (
                    campaign?.general_config?.enable_ticket_field &&
                    agent?.role === "agent"
                  ) {
                    <div class="info-item">
                      <div class="info-label">{{ 'agent.chat.label.ticket' | translate }}</div>
                      <div class="info-value">
                        <input
                          pInputText
                          class="ticket-input"
                          [(ngModel)]="ticketInput"
                          [placeholder]="'agent.chat.ticketIdPlaceholder' | translate"
                          [disabled]="!selectedConversation"
                          style="min-width: 220px; flex: 1 1 240px"
                        />
                        <p-button
                          [label]="
                            (selectedConversation.ticketId
                              ? 'agent.chat.update'
                              : 'agent.chat.save'
                            ) | translate
                          "
                          (click)="saveTicket()"
                          [disabled]="!ticketInput || !selectedConversation"
                        ></p-button>
                        <p-button
                          [label]="'agent.chat.clear' | translate"
                          styleClass="p-button-text"
                          (click)="ticketInput = ''; ticketSaved = false"
                          [disabled]="!ticketInput"
                        ></p-button>
                        <div
                          *ngIf="selectedConversation?.ticketId"
                          style="margin-top: 6px; color: var(--axede-muted)"
                        >
                          {{ 'agent.chat.currentTicket' | translate }}
                          <strong style="color: white">{{
                            selectedConversation.ticketId
                          }}</strong>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.fileUpload' | translate }}</div>
                    <div class="info-value">
                      {{
                        (campaign?.general_config?.enable_file_upload
                          ? 'agent.chat.enabledF'
                          : 'agent.chat.disabledF'
                        ) | translate
                      }}
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.fileDownload' | translate }}</div>
                    <div class="info-value">
                      {{
                        (campaign?.general_config?.enable_file_download
                          ? 'agent.chat.enabledF'
                          : 'agent.chat.disabledF'
                        ) | translate
                      }}
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- Agent Configuration Section -->
            <div class="info-section">
              <h3 class="info-section-title">
                <i class="pi pi-user"></i>
                {{ 'agent.chat.section.agentConfig' | translate }}
              </h3>
              <div class="info-section-grid">
                @if (agentConfigData && agentConfigData.enable) {
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.status' | translate }}</div>
                    <div class="info-value">{{ 'agent.chat.enabledM' | translate }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.campaignSelection' | translate }}</div>
                    <div class="info-value">{{ 'agent.chat.available' | translate }}</div>
                  </div>
                  @if (canSelectCampaign) {
                    <div class="info-item transfer-section">
                      <div class="info-label">{{ 'agent.chat.label.changeCampaign' | translate }}</div>
                      <div class="info-value">
                        <p-button
                          [label]="'agent.chat.selectCampaign' | translate"
                          icon="pi pi-megaphone"
                          styleClass="p-button-sm p-button-outlined"
                          [disabled]="
                            isLoadingCampaigns || !selectedConversation
                          "
                          (click)="openCampaignDialog()"
                          [loading]="isLoadingCampaigns"
                        >
                        </p-button>
                      </div>
                    </div>
                  }
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.agentId' | translate }}</div>
                    <div class="info-value">{{ agent?.id || ('agent.chat.na' | translate) }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.agentRole' | translate }}</div>
                    <div class="info-value">{{ agent?.role || ('agent.chat.na' | translate) }}</div>
                  </div>
                } @else {
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.status' | translate }}</div>
                    <div class="info-value">
                      {{
                        (agentConfigData
                          ? 'agent.chat.disabledM'
                          : 'agent.chat.notConfigured'
                        ) | translate
                      }}
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.information' | translate }}</div>
                    <div class="info-value">
                      {{ 'agent.chat.agentConfigUnavailable' | translate }}
                    </div>
                  </div>
                }
              </div>
            </div>

            <!-- Conversation Configuration Section -->
            <div class="info-section">
              <h3 class="info-section-title">
                <i class="pi pi-comments"></i>
                {{ 'agent.chat.section.conversationConfig' | translate }}
              </h3>
              <div class="info-section-grid">
                @if (conversationConfigData) {
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.automaticMessage' | translate }}</div>
                    <div class="info-value">
                      {{
                        (conversationConfigData.allow_automatic_message
                          ? 'agent.chat.enabledM'
                          : 'agent.chat.disabledF'
                        ) | translate
                      }}
                    </div>
                  </div>
                  @if (conversationConfigData.allow_automatic_message) {
                    <div class="info-item">
                      <div class="info-label">{{ 'agent.chat.label.frequencySeconds' | translate }}</div>
                      <div class="info-value">
                        {{ conversationConfigData.how_often_message || ('agent.chat.na' | translate) }}
                      </div>
                    </div>
                    <div class="info-item">
                      <div class="info-label">{{ 'agent.chat.label.automaticMessage' | translate }}</div>
                      <div class="info-value">
                        {{
                          conversationConfigData.automatic_message_value ||
                            ('agent.chat.notDefined' | translate)
                        }}
                      </div>
                    </div>
                  }
                } @else {
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.status' | translate }}</div>
                    <div class="info-value">{{ 'agent.chat.notConfigured' | translate }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.information' | translate }}</div>
                    <div class="info-value">
                      {{ 'agent.chat.conversationConfigUnavailable' | translate }}
                    </div>
                  </div>
                }
              </div>
            </div>

            <!-- Time Settings Configuration Section -->
            <div class="info-section">
              <h3 class="info-section-title">
                <i class="pi pi-clock"></i>
                {{ 'agent.chat.section.timeConfig' | translate }}
              </h3>
              <div class="info-section-grid">
                @if (timeSettingsData && timeSettingsData.enable) {
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.status' | translate }}</div>
                    <div class="info-value">{{ 'agent.chat.enabledM' | translate }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.attentionDays' | translate }}</div>
                    <div class="info-value">
                      {{
                        timeSettingsData.days.join(", ") || ('agent.chat.notSpecified' | translate)
                      }}
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.startTime' | translate }}</div>
                    <div class="info-value">
                      {{
                        formatTimeSettings(timeSettingsData.start_time) ||
                          ('agent.chat.notSpecified' | translate)
                      }}
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.endTime' | translate }}</div>
                    <div class="info-value">
                      {{
                        formatTimeSettings(timeSettingsData.end_time) ||
                          ('agent.chat.notSpecified' | translate)
                      }}
                    </div>
                  </div>
                } @else {
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.status' | translate }}</div>
                    <div class="info-value">
                      {{
                        (timeSettingsData
                          ? 'agent.chat.disabledM'
                          : 'agent.chat.notConfigured'
                        ) | translate
                      }}
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">{{ 'agent.chat.label.information' | translate }}</div>
                    <div class="info-value">
                      {{ 'agent.chat.timeConfigUnavailable' | translate }}
                    </div>
                  </div>
                }
              </div>
            </div>

            <div class="info-section info-section-actions">
              <p-button
                [label]="'agent.chat.backToChat' | translate"
                icon="pi pi-comments"
                styleClass="p-button-outlined info-back-button"
                (click)="toggleInfoPanel()"
              ></p-button>
            </div>
          </div>
        </div>
      }
    </ng-template>

    <!-- Campaign Selection Dialog -->
    <p-dialog
      [header]="'agent.chat.selectCampaign' | translate"
      [(visible)]="showCampaignDialog"
      [modal]="true"
      [style]="{ width: '450px' }"
      [contentStyle]="{ overflow: 'visible' }"
      [draggable]="false"
      [resizable]="false"
      [closable]="true"
      [baseZIndex]="1000"
      (onHide)="closeCampaignDialog()"
    >
      <div class="transfer-dialog-content">
        <div class="transfer-info">
          <p>
            <strong>{{ 'agent.chat.dialog.conversationId' | translate }}</strong>
            {{ selectedConversation.conversationId }}
          </p>
          <p><strong>{{ 'agent.chat.dialog.client' | translate }}</strong> {{ selectedConversation.clientId }}</p>
          <p>
            <strong>{{ 'agent.chat.dialog.currentCampaign' | translate }}</strong>
            {{ campaign?.campaign_name || ('agent.chat.na' | translate) }}
          </p>
        </div>

        <div class="agent-selection">
          <label for="campaignSelect" class="transfer-label"
            >{{ 'agent.chat.dialog.selectNewCampaign' | translate }}</label
          >

          @if (isLoadingCampaigns) {
            <div class="loading-agents">
              <i class="pi pi-spin pi-spinner"></i>
              <span>{{ 'agent.chat.dialog.loadingCampaigns' | translate }}</span>
            </div>
          } @else if (availableCampaigns.length === 0) {
            <div class="no-agents">
              <i class="pi pi-info-circle"></i>
              <span>{{ 'agent.chat.dialog.noCampaigns' | translate }}</span>
            </div>
          } @else {
            <p-dropdown
              id="campaignSelect"
              [(ngModel)]="selectedCampaign"
              [options]="availableCampaigns"
              optionLabel="campaign_name"
              [placeholder]="'agent.chat.dialog.campaignPlaceholder' | translate"
              [style]="{ width: '100%' }"
              [showClear]="true"
              appendTo="body"
              [panelStyle]="{ maxHeight: '200px' }"
              scrollHeight="200px"
            >
              <ng-template pTemplate="selectedItem">
                @if (selectedCampaign) {
                  <div class="selected-agent">
                    <i class="pi pi-megaphone"></i>
                    <span
                      >{{ selectedCampaign.campaign_name }} ({{
                        selectedCampaign.type
                      }})</span
                    >
                  </div>
                }
              </ng-template>

              <ng-template pTemplate="item" let-campaign>
                <div class="agent-option">
                  <div class="agent-info">
                    <div class="agent-name">{{ campaign.campaign_name }}</div>
                    <!-- <div class="agent-email">{{campaign.type}} - {{campaign.state}}</div> -->
                    @if (campaign.priority) {
                      <div class="agent-role">
                        {{ 'agent.chat.dialog.priority' | translate }} {{ campaign.priority }}
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </p-dropdown>
          }
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="transfer-dialog-footer">
          <p-button
            [label]="'agent.chat.cancel' | translate"
            icon="pi pi-times"
            styleClass="p-button-text p-button-outlined"
            [disabled]="isLoadingCampaigns"
            (click)="closeCampaignDialog()"
          >
          </p-button>

          <p-button
            [label]="'agent.chat.select' | translate"
            icon="pi pi-check"
            styleClass="p-button-primary"
            [disabled]="!selectedCampaign || isLoadingCampaigns"
            [loading]="isLoadingCampaigns"
            (click)="selectCampaign()"
          >
          </p-button>
        </div>
      </ng-template>
    </p-dialog>
  </p-card>
} @else {
  <app-agent-panel-metrics></app-agent-panel-metrics>
}
